class LocationSwitcher extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.locations = this.querySelectorAll(".location-item");
  }

  connectedCallback() {
    this.hideAll();

    if (this.locations.length > 0) {
      this.locations[0].style.display = "block";
    }

    this.select.addEventListener("change", this.onChange.bind(this));
  }

  hideAll() {
    this.locations.forEach(el => el.style.display = "none");
  }

  onChange() {
    this.hideAll();
    const selected = this.select.value;
    const target = this.querySelector("." + selected);
    if (target) target.style.display = "block";
  }
}

customElements.define("location-switcher", LocationSwitcher);
